import { render } from "./SystemRequestView.vue?vue&type=template&id=18562a81"
import script from "./SystemRequestView.vue?vue&type=script&lang=js"
export * from "./SystemRequestView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__